export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return null;

  const now = Math.floor(Date.now() / 1000);
  const delta = now - timestamp;

  const minute = 60;
  const hour = 60 * 60;
  const day = 60 * 60 * 24;

  // < 1 minute: show "<1 minute ago"
  if (delta < minute) return "<1 minute ago";

  // >= 1 minute but < 1 hour: show minutes (no seconds)
  if (delta < hour) {
    const mins = Math.floor(delta / minute);
    return mins === 1 ? "1 minute ago" : `${mins} minutes ago`;
  }

  // >= 1 hour but < 1 day: show hours (no minutes)
  if (delta < day) {
    const hrs = Math.floor(delta / hour);
    return hrs === 1 ? "1 hour ago" : `${hrs} hours ago`;
  }

  // >= 1 day: show days
  const days = Math.floor(delta / day);
  return days === 1 ? "1 day ago" : `${days} days ago`;
};

export const formatRelativeTimeDaysOnly = (timestamp) => {
  if (!timestamp) return null;

  const now = Math.floor(Date.now() / 1000);
  const delta = now - timestamp;
  const day = 60 * 60 * 24;

  // < 1 day: show "<1 day"
  if (delta < day) return "<1 day";

  // >= 1 day: show number of days
  const days = Math.floor(delta / day);
  return days === 1 ? "1 day" : `${days} days`;
};

const LOCALE_WHITELIST = ["en-GB", "en-US"];
const userLocale = new Intl.NumberFormat().resolvedOptions().locale;
const LOCALE = LOCALE_WHITELIST.includes(userLocale) ? userLocale : "en-GB";

export const formatDateWithOrdinal = (timestamp, options = {}) => {
  const date = new Date(timestamp * 1000);

  const getOrdinalSuffix = (n) => {
    if (n >= 11 && n <= 13) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const day = date.getDate();
  const month = date.toLocaleString(LOCALE, { month: "short" });
  const year = date.getFullYear();

  const suffix = getOrdinalSuffix(day);

  const comma = options.includeComma ? "," : "";

  return LOCALE === "en-US"
    ? `${month} ${day}${suffix}${comma} ${year}`
    : `${day}${suffix} ${month}${comma} ${year}`;
};
